import { Text } from '@rbilabs/universal-components';
import { MenuAcceleratorBadgeBigSvg } from 'features/menu/components/menu-accelerator-badge/menu-accelerator-badge-svg';
import { BonusType, BonusTypes } from 'features/menu/components/menu-accelerator-badge/types';
import { parseBonusPoints } from 'features/menu/components/menu-accelerator-badge/utils';
import { StyleSheet, View } from 'react-native';

import { useIsDesktopBreakpoint } from 'hooks/use-media-query';

interface IMenuAcceleratorBadge {
  position?: 'absolute' | '';
  bonusPoints: number;
  pointsMultiplier: number;
}

export const MenuAcceleratorBadge = ({
  position = '',
  bonusPoints,
  pointsMultiplier,
}: IMenuAcceleratorBadge) => {
  const isDesktop = useIsDesktopBreakpoint();
  const bonusType: BonusType = bonusPoints ? BonusTypes.BONUS_POINTS : BonusTypes.POINTS_MULTIPLIER;
  const bonusText =
    bonusType === BonusTypes.BONUS_POINTS
      ? `+${parseBonusPoints(bonusPoints)}`
      : `${pointsMultiplier}x`;
  return (
    <View
      style={[
        styles.container,
        position === 'absolute' ? { position, left: isDesktop ? 50 : 0 } : { right: 10 },
      ]}
    >
      <MenuAcceleratorBadgeBigSvg />
      <View style={styles.badge}>
        <Text variant="copyTwo" fontWeight="bold">
          {bonusText}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    top: 0,
    left: 0,
    zIndex: 9999,
    height: 36,
    width: 36,
    alignItems: 'center',
    justifyContent: 'center',
  },
  badge: {
    position: 'absolute',
    top: 14,
  },
});
